<template>
  <form @submit.prevent="login"><span class="eyebrow">ДОБРО ПОЖАЛОВАТЬ</span><h2>Войти в кабинет</h2><p class="muted">Используйте логин и пароль, полученные от менеджера.</p>
    <label>Логин<input v-model.trim="credentials.login" autocomplete="username" required maxlength="250"></label>
    <label>Пароль<input v-model="credentials.password" type="password" autocomplete="current-password" required maxlength="1024"></label>
    <p v-if="error" class="error" role="alert">{{ error }}</p><button class="primary" :disabled="busy">{{ busy ? 'Входим…' : 'Войти →' }}</button>
    <p class="help">Не получается войти? Обратитесь к своему менеджеру для восстановления доступа.</p>
  </form>
</template>
<script>
import { loginDestination } from '@/utils/loginRedirect'
export default {
  data: () => ({ credentials: { login: '', password: '' }, busy: false, error: '' }),
  methods: {
    async login() {
      this.busy = true; this.error = ''
      try { await this.$store.dispatch('login', this.credentials); this.credentials.password = ''; await this.$router.replace(loginDestination(this.$route.query.redirect)) }
      catch (error) { this.error = error.message }
      finally { this.busy = false }
    }
  }
}
</script>
